import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/3c11c6422cef54f02aa5e5910cede997.jpg"
          alt="Premium flooring installation New Jersey"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
      </div>

      {/* Floating accent line */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-40 bg-gradient-to-b from-transparent via-gold to-transparent hidden lg:block" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-36 pb-28">
        <div className="max-w-2xl">
          {/* Tag */}
          <div
            className="flex items-center gap-3 mb-8"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(16px)',
              transition: 'all 0.6s ease',
            }}
          >
            <span className="gold-line" />
            <span className="section-tag text-gold">Licensed &amp; Insured · Freehold, NJ</span>
          </div>

          {/* H1 */}
          <h1
            className="font-serif text-5xl lg:text-6xl xl:text-7xl text-white leading-[1.06] mb-8"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(24px)',
              transition: 'all 0.75s ease 0.1s',
            }}
          >
            Premium Carpet &amp;<br />
            Flooring Installation{' '}
            <em className="text-gold not-italic">Done Right</em>
          </h1>

          {/* Sub */}
          <p
            className="text-white/70 text-lg lg:text-xl leading-relaxed mb-12 max-w-lg"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.75s ease 0.2s',
            }}
          >
            High-quality carpet, hardwood, and specialty flooring for residential and commercial spaces — built to last, designed to impress.
          </p>

          {/* CTAs */}
          <div
            className="flex flex-col sm:flex-row gap-4"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.75s ease 0.3s',
            }}
          >
            <button onClick={scrollToContact} className="btn-primary text-base">
              Request a Design Consultation
            </button>
            <a href="tel:1-866-732-2966" className="btn-secondary text-base flex items-center justify-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </span>
              Call 1-866-732-2966
            </a>
          </div>

          {/* Badge row */}
          <div
            className="flex flex-wrap items-center gap-6 mt-12"
            style={{
              opacity: visible ? 1 : 0,
              transition: 'all 0.75s ease 0.45s',
            }}
          >
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-line text-gold text-sm"></i>
              </span>
              <span className="text-white/50 text-xs">Responds within minutes</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex">
                {[1,2,3,4,5].map(s => (
                  <span key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-gold text-xs"></i>
                  </span>
                ))}
              </div>
              <span className="text-white/50 text-xs">5-Star Rated Service</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-gold text-sm"></i>
              </span>
              <span className="text-white/50 text-xs">Fully Licensed &amp; Insured</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 hidden lg:flex flex-col items-center gap-2.5 opacity-40">
        <span className="text-white text-xs tracking-widest uppercase font-light">Scroll</span>
        <span className="w-px h-12 bg-white/30 animate-pulse" />
      </div>
    </section>
  );
}
